export function removeMoneyMask(word: string): number {
  const numberPattern = /\d+|,/g;
  return Number(word?.match(numberPattern)?.join('')?.replace(/,/g, '.'));
}
